import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'rr-ai-control',
  standalone: false,
  templateUrl: './ai-control.component.html',
  styleUrl: './ai-control.component.scss'
})
export class AiControlComponent implements AfterViewInit {
  @Input() text1: string = ""
  @Input() text2: string = ""
  @Input() text3: string = ""
  @Input() placeholder: string = ""
  @Input() control: FormControl = new FormControl()
  @Input() necessaryWords: number = 3;
  maxRows: number = 3;
  row: number = 1
  charCount: number = 0;
  textareaValue: string = ""
  totalDiabledStatus: boolean = true;
  showAgentRow: boolean = false;
  showAgentSuggestions: boolean = false;

  aiIsRunning: boolean = false;

  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('textarea') textarea!: ElementRef<HTMLTextAreaElement>;


  suggestions: any[] = [];

  constructor(
    private cdr: ChangeDetectorRef
  ) {
    this.control.valueChanges.subscribe((value) => {
      this.checkINputValidation();
    });
  }

  ngAfterViewInit() {
    this.checkINputValidation();
    this.cdr.detectChanges();
  }

  stopAiQuery() {
    console.log('AI is stopped');
    this.aiIsRunning = false;
    this.showAgentRow = false;
    this.showAgentSuggestions = false;
  }
  startAiQuery() {
    console.log('AI is running');

    this.aiIsRunning = true;
    this.showAgentRow = true;
    this.showAgentSuggestions = true;
  }

  checkINputValidation() {
    let findWords = this.control.value?.split(' ').length;
    let lastWord = this.control.value?.split(' ').pop();

    if (findWords > this.necessaryWords || (findWords === this.necessaryWords && lastWord.length > 0)) {
      this.totalDiabledStatus = false;
    } else {
      this.totalDiabledStatus = true;
    }

  }
  addSuggestionToTextarea(suggestion: string) {
    this.control.setValue(suggestion);
    this.showAgentSuggestions = false;
  }
  onInput(event: Event) {
    const textarea = this.textarea.nativeElement;
    const style = window.getComputedStyle(textarea);
    const lineHeight = parseInt(style.lineHeight, 10);
    const paddingTop = parseInt(style.paddingTop, 10);
    const paddingBottom = parseInt(style.paddingBottom, 10);
    const totalPadding = paddingTop + paddingBottom;
    const lines = Math.floor((textarea.scrollHeight - totalPadding) / lineHeight);

    if (lines > this.maxRows) {
      this.charCount = textarea.value.length;
      const trimmedValue = textarea.value.slice(0, this.charCount - 1);
      textarea.value = trimmedValue;
      this.control.setValue(trimmedValue);
      return;
    }
    this.row = lines;
    this.checkINputValidation();

  }
}
